"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _Services = require("../common_features/utility/Services");
var _ServiceHistoryDetails = _interopRequireDefault(require("../components/ServiceHistoryDetails"));
var _helper = require("../common_features/utility/helper");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _lodash = _interopRequireDefault(require("lodash"));
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const WaterInfo = () => {
  const {
    selectedSystems,
    selectedDetails
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const dispatch = (0, _reactRedux.useDispatch)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [serviceLogsType, setServiceLogsType] = (0, _react.useState)(2);
  const [systemPartData, setSystemPartData] = (0, _react.useState)({});
  const [notes, setNotes] = (0, _react.useState)("");
  const [isRO, setRO] = (0, _react.useState)(true);
  const data = isRO ? {
    InletTds: '',
    pretreatmentValue: "No",
    InletHardness: '',
    InletTemp: '',
    InletPressure: '',
    pressureDrop: '',
    PermeateTds: '',
    BlendedTds: '',
    RejectTds: '',
    PermeateFlowRate: '',
    RejectedFlow: '',
    preCharge: '',
    Recovery: '',
    ...selectedDetails
  } : {
    InletTds: '',
    pretreatmentValue: "No",
    InletHardness: '',
    InletTemp: '',
    InletPressure: '',
    pressureDrop: '',
    ...selectedDetails
  };
  const [details, setDetails] = (0, _react.useState)({
    ...data
  });
  const [initialDetails, setInitialDetails] = (0, _react.useState)({
    ...details
  });
  const [pretreatmentValue, setpretreatmentValue] = (0, _react.useState)(data.pretreatmentValue == "Yes");
  (0, _react.useEffect)(async () => {
    setIsLoading(true);
    const systemData = await (0, _Services.GetAddSystemDetails)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber);
    setSystemPartData(systemData);
    setRO(systemData["System Type"] === "RO System" ? true : false);
    if (!_lodash.default.isEmpty(selectedDetails)) {
      setIsLoading(false);
      return;
    }
    const refAppId = null;
    (0, _Services.getLastServiceRecordByType)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemId, _helper.SERVICE_LOGS_TYPE.WATER_DETAILS_UPDATED, refAppId).then(data => {
      var _data$data$ServiceLog, _data$data, _data$data$ServiceLog2, _data$data$ServiceLog3, _data$data2, _data$data2$ServiceLo, _data$data2$ServiceLo2, _data$data3;
      const notes = (_data$data$ServiceLog = data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$ServiceLog2 = _data$data.ServiceLogNotes) === null || _data$data$ServiceLog2 === void 0 ? void 0 : (_data$data$ServiceLog3 = _data$data$ServiceLog2[0]) === null || _data$data$ServiceLog3 === void 0 ? void 0 : _data$data$ServiceLog3.note) !== null && _data$data$ServiceLog !== void 0 ? _data$data$ServiceLog : "";
      const readings = data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : (_data$data2$ServiceLo = _data$data2.ServiceLogReadings) === null || _data$data2$ServiceLo === void 0 ? void 0 : (_data$data2$ServiceLo2 = _data$data2$ServiceLo[0]) === null || _data$data2$ServiceLo2 === void 0 ? void 0 : _data$data2$ServiceLo2.readings;
      const serviceLogsType = data === null || data === void 0 ? void 0 : (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.serviceLogsType;
      setServiceLogsType(serviceLogsType);
      setNotes(notes);
      setpretreatmentValue((readings === null || readings === void 0 ? void 0 : readings.pretreatmentValue) == "Yes");
      setDetails({
        ...readings
      });
      setInitialDetails({
        ...readings
      });
      setIsLoading(false);
    }).catch(e => {
      setIsLoading(false);
    });
  }, []);
  const calculateRecovery = () => {
    const numerator = Number(details === null || details === void 0 ? void 0 : details.PermeateFlowRate);
    const denominator = Number(details === null || details === void 0 ? void 0 : details.PermeateFlowRate) + Number(details === null || details === void 0 ? void 0 : details.RejectedFlow);
    const recovery = numerator / denominator * 100;
    return +parseFloat(recovery).toFixed(2);
  };
  const calculateAndSetRecovery = () => {
    if (details !== null && details !== void 0 && details.PermeateFlowRate && details !== null && details !== void 0 && details.RejectedFlow) {
      const calculatedRecovery = calculateRecovery();
      setDetails(prevDetails => ({
        ...prevDetails,
        Recovery: calculatedRecovery ? calculatedRecovery : '--'
      }));
    } else {
      setDetails(prevDetails => ({
        ...prevDetails,
        Recovery: '--'
      }));
    }
  };
  (0, _react.useEffect)(() => {
    systemPartData["System Type"] === "RO System" && calculateAndSetRecovery();
  }, [details === null || details === void 0 ? void 0 : details.PermeateFlowRate, details === null || details === void 0 ? void 0 : details.RejectedFlow]);
  const handleBack = () => {
    navigate(-1);
  };
  const navigateToNotes = () => {
    dispatch((0, _systemsReducer.setSelectedDetails)({
      ...details
    }));
    const changesFlag = !_lodash.default.isEqual(initialDetails, details);
    let notesToPass = !changesFlag ? notes : "";
    if (serviceLogsType == 1 || (0, _helper.isTimeDifference24Hours)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.createdAt, new Date().toISOString())) notesToPass = "";
    navigate(_RoutePath.default.addNotes.useLink, {
      state: {
        changesFlag: changesFlag,
        serviceLogType: _helper.SERVICE_LOGS_TYPE.WATER_DETAILS_UPDATED,
        notes: notesToPass,
        isFromWaterInfo: true,
        successModalTitle: "Water Info Updated",
        successModalDetail: "Water Info has been updated successfully.",
        payload: {
          ServiceLogReading: {
            readings: details
          }
        }
      }
    });
  };
  const pretreatmentChecked = () => {
    setDetails({
      ...details,
      pretreatmentValue: !pretreatmentValue ? 'Yes' : 'No'
    });
    setpretreatmentValue(!pretreatmentValue);
  };
  const onKeyPress = event => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ServiceHistoryDetails.default, {
    saveButtonTitle: "Continue",
    onKeyPress: onKeyPress,
    isUpdating: isLoading,
    showSteps: false,
    backNavigationScreen: 'System Dashboard',
    subContent: "".concat(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber, " ").concat(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber),
    handleBack: handleBack,
    handleCancle: handleBack,
    rightNavHeading: "Cancel",
    headerText: "Edit Water Info",
    subHeaderText: 'Water Info',
    saveBtnClick: navigateToNotes,
    isRo: isRO,
    pretreatmentValue: pretreatmentValue,
    pretreatmentChecked: pretreatmentChecked,
    details: details,
    inletTdsChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.InletTds) != (details === null || details === void 0 ? void 0 : details.InletTds),
    onChangeInletTds: e => setDetails({
      ...details,
      InletTds: e.target.value
    }),
    inletHardnessChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.InletHardness) != (details === null || details === void 0 ? void 0 : details.InletHardness),
    onChangeInletHardness: e => setDetails({
      ...details,
      InletHardness: e.target.value
    }),
    inletTempChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.InletTemp) != (details === null || details === void 0 ? void 0 : details.InletTemp),
    onChangeInletTemp: e => setDetails({
      ...details,
      InletTemp: e.target.value
    }),
    inletPressureChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.InletPressure) != (details === null || details === void 0 ? void 0 : details.InletPressure),
    onChangeInletPressure: e => setDetails({
      ...details,
      InletPressure: e.target.value
    }),
    pressureDropChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.pressureDrop) != (details === null || details === void 0 ? void 0 : details.pressureDrop),
    onChangepressureDrop: e => setDetails({
      ...details,
      pressureDrop: e.target.value
    }),
    permeateTdsChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.PermeateTds) != (details === null || details === void 0 ? void 0 : details.PermeateTds),
    onChangePermeateTds: e => setDetails({
      ...details,
      PermeateTds: e.target.value
    }),
    rejectTdsChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.RejectTds) != (details === null || details === void 0 ? void 0 : details.RejectTds),
    onChangeRejectTds: e => setDetails({
      ...details,
      RejectTds: e.target.value
    }),
    permeateFlowRateChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.PermeateFlowRate) != (details === null || details === void 0 ? void 0 : details.PermeateFlowRate),
    onChangePermeateFlowRate: e => setDetails({
      ...details,
      PermeateFlowRate: e.target.value
    }),
    rejectedFlowChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.RejectedFlow) != (details === null || details === void 0 ? void 0 : details.RejectedFlow),
    onChangeRejectedFlow: e => setDetails({
      ...details,
      RejectedFlow: e.target.value
    }),
    blendedTdsChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.BlendedTds) != (details === null || details === void 0 ? void 0 : details.BlendedTds),
    onChangeBlendedTds: e => setDetails({
      ...details,
      BlendedTds: e.target.value
    }),
    preChargeChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.preCharge) != (details === null || details === void 0 ? void 0 : details.preCharge),
    onChangePreCharge: e => setDetails({
      ...details,
      preCharge: e.target.value
    }),
    recoveryChanged: (initialDetails === null || initialDetails === void 0 ? void 0 : initialDetails.Recovery) != (details === null || details === void 0 ? void 0 : details.Recovery),
    onChangeRecovery: e => setDetails({
      ...details,
      Recovery: e.target.value
    })
  });
};
var _default = exports.default = WaterInfo;